<template>
  <div>
    <div class="inline">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Thông tin khách hàng/nhà cung cấp'">
          <template v-slot:preview>
            <customer-form
              :is-edit-mode="false"
              submit-button-text="Lưu"
              @submit-success="createCustomer"
              @submit-error="handleError"
            />
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, getCurrentInstance } from 'vue';
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import moment from 'moment';
import { makeToastSuccess, makeToastFaile, handleError } from '@/utils/common';
import CustomerForm from './components/CustomerForm.vue';

export default defineComponent({
  name: 'AddCustomer',

  components: {
    KTCodePreview,
    CustomerForm,
  },

  setup() {
    const { proxy } = getCurrentInstance();

    onMounted(() => {
      proxy.$store.dispatch(SET_BREADCRUMB, [
        { title: 'Khách hàng', route: '/customers' },
        { title: 'Thêm mới khách hàng' },
      ]);
    });

    const createCustomer = async (formData) => {
      try {
        const dateOfBirth = formData.dateOfBirth
          ? moment(formData.dateOfBirth, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : '';
        const apiData = {
          ...formData,
          email: formData.email || null,
          creditLimit: Number(formData.creditLimit) || 0,
          supplierGroupId:
            formData.supplierGroupId === '' ? null : formData.supplierGroupId,
          paymentTermsDays:
            formData.paymentTermsDays === '' ? null : formData.paymentTermsDays,
          identifyNo: formData.identifyNo?.trim() || null,
          code: formData.code?.trim() || null,
          shippingAddress1: formData.shippingAddress1?.trim() || null,
          shippingAddress2: formData.shippingAddress2?.trim() || null,
          inChargeEmployeeName: formData.inChargeEmployeeName?.trim() || null,
          dateOfBirth: dateOfBirth || null,
        };

        await ApiService.post('/v1/customers', apiData);
        makeToastSuccess('Thêm khách hàng thành công');
        proxy.$router.push('/customers');
      } catch (error) {
        handleError(error);
      }
    };

    return {
      createCustomer,
    };
  },
});
</script>
